/** The days of Beheer › Bestellingen per dag. */

/**
 * The day of the shop starts at 06:00 (server BUSINESS_DAY_START_HOUR; Furkan, 11/10/2026): a night's
 * sales are the evening's.
 */
const DAY_START_HOURS = 6;

/** Today's business day in Belgium, "2026-10-09". */
export function businessDayOf(at: Date): string {
  return new Intl.DateTimeFormat("en-CA", { timeZone: "Europe/Brussels" }).format(
    new Date(at.getTime() - DAY_START_HOURS * 3_600_000),
  );
}

/** The day before or after, "2026-10-04" ± 1. */
export function shiftDay(day: string, by: number): string {
  const date = new Date(`${day}T12:00:00Z`);
  date.setUTCDate(date.getUTCDate() + by);
  return date.toISOString().slice(0, 10);
}
